import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { LegalFooter } from "./LegalFooter";
export function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box
        component="main"
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TopBar onMenuToggle={() => setMobileOpen(!mobileOpen)} />
        <Box
          sx={{
            flex: 1,
            overflow: "auto",
            p: { xs: 1.5, sm: 2, md: 4 },
            WebkitOverflowScrolling: "touch",
          }}
        >
          <Outlet />
        </Box>
        <LegalFooter />
      </Box>
    </Box>
  );
}
